module.exports = __webpack_public_path__ + "static/media/bgsidebar.5d17a111.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/bgsidebar.png
// module id = 456
// module chunks = 1